import { z } from 'zod'

export const MCPSERVER_PUBLIC_READ_CONTRACT_VERSION = '1.0.0' as const

const mcpServerToolSchema = z.object({
  name: z.string(),
  description: z.string(),
  inputSchema: z.object({
    type: z.literal('object'),
    properties: z.record(z.unknown()),
    required: z.array(z.string()).optional(),
  }).passthrough(),
}).passthrough()

export const mcpserverRootResponseSchema = z.object({
  name: z.string(),
  version: z.string(),
  description: z.string(),
  endpoints: z.record(z.string()),
  tools: z.number(),
}).passthrough()

export const mcpserverToolsResponseSchema = z.object({
  jsonrpc: z.literal('2.0'),
  id: z.string(),
  result: z.object({
    tools: z.array(mcpServerToolSchema),
  }).passthrough(),
}).passthrough()

export const mcpserverToolsChatgptResponseSchema = mcpserverToolsResponseSchema

export type McpserverRootResponse = z.infer<typeof mcpserverRootResponseSchema>
export type McpserverToolsResponse = z.infer<typeof mcpserverToolsResponseSchema>
export type McpserverToolsChatgptResponse = z.infer<typeof mcpserverToolsChatgptResponseSchema>
